var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-bar"},[_c('div',{staticStyle:{"flex":"1"}},[_vm._t("default")],2),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }